<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="action">
    <div slot="header" class="modal-header">{{text}}</div>   
    <p>确认要{{text}}目标房源吗?</p>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { batchAboveOrUnder} from "api/house"
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    subHandleUnderKey:{
      type:Number,
      default:0
    },
    // 操作类型 0为批量上架，1为批量下架 
    handleType:{
      type:Number,
      default:0
    },
    stockFidList:{
      type:String,
      default:''
    },
     isBatch: {
      type:Boolean,
      default:true
    },
  },
  computed:{
    text() {
     return  this.isBatch ? (this.handleType ==0 ? '批量上架' :'批量下架') : (this.handleType ==0 ? '上架' :'下架')
      // return this.handleType ==0 ? '批量上架' :'批量下架'
    }
  },
  data () {
    return {
       show:false
    };
  },
  watch:{
   n(val){
     this.show = true;
   },
   subHandleUnderKey(val) {
     this.show = true
   }
 },
  methods:{
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    action(){
      let data = {
        stockFidList:this.stockFidList,
        stockIsUnder: this.handleType
      }
      batchAboveOrUnder(data).then( res => {
        this.changeLoading();
        this.$Message.success(`${this.text}成功`);
        this.show = false;
        this.$emit('refresh')
      }).catch(error => {
        this.changeLoading(); 
      })
   }
  }
}
</script>
